import { render, staticRenderFns } from "./TruckSelection.vue?vue&type=template&id=4d5a1490"
import script from "./TruckSelection.ts?vue&type=script&lang=ts&external"
export * from "./TruckSelection.ts?vue&type=script&lang=ts&external"
import style0 from "./TruckSelection.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports